import React from "react";

const Bulb = ({ size = 32, ...rest }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g id="lightbulb-05">
                <path
                    id="Icon"
                    d="M16 2.66675V4.00008M4.00002 16.0001H2.66669M7.33335 7.33341L6.53322 6.53328M24.6667 7.33341L25.467 6.53328M29.3334 16.0001H28M13.3334 18.0001H18.6667M16 18.0001V24.6667M20.6667 22.4987C22.6854 21.0464 24 18.6768 24 16.0001C24 11.5818 20.4183 8.00008 16 8.00008C11.5817 8.00008 8.00002 11.5818 8.00002 16.0001C8.00002 18.6768 9.3146 21.0464 11.3334 22.4987V25.0667C11.3334 26.5602 11.3334 27.307 11.624 27.8774C11.8797 28.3792 12.2876 28.7871 12.7894 29.0428C13.3598 29.3334 14.1065 29.3334 15.6 29.3334H16.4C17.8935 29.3334 18.6402 29.3334 19.2107 29.0428C19.7124 28.7871 20.1204 28.3792 20.376 27.8774C20.6667 27.307 20.6667 26.5602 20.6667 25.0668V22.4987Z"
                    stroke="currentColor"
                    strokeWidth="2.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

export default Bulb;
